<!--
 * @Author: zly
 * @Date: 2021-07-20 15:30:54
 * @LastEditTime: 2024-06-12 17:23:08
 * @LastEditors: 汪俊洪
 * @Description: 弹窗上传组件 fileSuccess为成功导入回调
-->
<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose"
      class="upload-box"
      :append-to-body="appendToBody"
      :modal-append-to-body="modalAppendToBody"
      :center="center"
    >
      <slot name="des"></slot>
      <div style="margin-bottom: 10px" v-if="downUrl">
        {{ downUrlPrefix }}
        <el-button v-if="!isArray" type="text" @click="downTemp(downUrl)"
          >点击下载</el-button
        >
        <el-button
          v-else
          v-for="item in downUrl"
          @click="downTemp(item.url)"
          :key="item.name"
          type="text"
          >{{ item.name }}</el-button
        >
      </div>
      <el-upload
        ref="upload"
        :class=" draggable ? 'upload-draggable' : ''"
        :action="url"
        :drag="draggable"
        :on-success="handleAvatarSuccess"
        :before-remove="beforeRemove"
        :on-remove="handleRemove"
        :before-upload="beforeAvatarUpload"
        :on-change="beforeUpload"
        :accept="accept"
        :multiple="multiple"
        :limit="limit"
        :on-exceed="handleExceed"
        :file-list="fileList"
        :auto-upload="false"
      >
        <el-button size="small" type="primary" v-if="!draggable"
          >点击上传</el-button
        >
        <template v-else>
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            拖拽文件到此处上传,或<em>点击上传</em><br />支持扩展名：{{ accept }}，文件大小不超过{{ size }}M
          </div>
        </template>
        <template slot="tip" v-if="!draggable">
          <slot name="tip">
            <div slot="tip" class="el-upload__tip">
              只能上传{{ accept }}文件，且不超过{{ size }}MB
            </div>
          </slot>
        </template>
      </el-upload>
      <slot name="extra" v-if="fileList.length"></slot>
      <slot name="other"></slot>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="saveBtn()"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import NProgress from 'nprogress' // progress bar
// import 'nprogress/nprogress.css' // progress bar style
export default {
  props: {
    title: {
      // 上传文件弹窗标题
      type: String,
      default: '导入文件'
    },
    dialogVisible: {
      // 是否打开弹窗
      type: Boolean,
      default: () => true
    },
    size: {
      // 上传文件大小限制 单位为MB 默认为2Mb
      type: [Number],
      default: () => 2
    },
    accept: {
      // 上传文件格式
      type: String,
      default: () => '.xls,.xlsx,.doc,.docx,.png,.jpg,.jpeg'
    },
    limit: {
      // 上传文件最大数量 默认为1
      type: [Number],
      default: () => 1
    },
    url: {
      // 上传请求地址
      type: String,
      default: () =>
        window.SITE_CONFIG.apiURL + '/front/fileupload/alioss/upload'
    },
    downUrl: {
      // 下载模版入参 参数 单个或者多个
      type: [Array, String, Function],
      default: () => null // 单个直接传url地址  [有多个的时候] [{name:'点击下载1', url:'http://baidu.com'}]
    },
    fileKey: {
      // 对应文件的上传字段标示，不传默认为file
      type: [Object, String],
      default: () => '' // {'施耐德A9.zip':'file'} key value格式，文件名和文件上传字段
    },
    suffixKey: {
      // 对应文件的上传后缀名标示，不传默认为file,file默认数组形式,不能重复定义value的值
      type: [Object, String],
      default: () => '' // { zipFile: 'zip', file: ['xlsx', 'xls'] }
    },
    modalAppendToBody: {
      // 遮罩层是否插入至 body 元素上，若为 false，则遮罩层会插入至 Dialog 的父元素上
      type: Boolean,
      default: true
    },
    appendToBody: {
      // 是否将弹层放到body中,默认把弹层放在所属组件中
      type: Boolean,
      default: false
    },
    extra: {
      // 上传接口新增额外参数
      type: Object,
      default: () => ({})
    },
    inputParam: {
      // extra参数是否聚合到一个入参中
      type: String,
      default: ''
    },
    message: {
      // 上传成功提示
      type: [String],
      default: () => ''
    },
    center: {
      // 弹层是否居中布局
      type: Boolean,
      default: false
    },
    check: {
      // 是否在点击保存按钮的时候增加外部校验
      type: Boolean,
      default: false
    },
    downUrlPrefix: {
      default: '模版下载:',
      type: String
    },
    draggable: {
      // 是否支持拖拽上传
      default: false,
      type: Boolean
    }
  },
  computed: {
    multiple () {
      let multiple = false
      if (this.limit > 1) {
        multiple = true
      } else {
        multiple = false
      }
      return multiple
    },
    isArray () {
      const isArray = Array.isArray(this.downUrl)
      return isArray
    }
  },
  data () {
    return {
      fileList: [], // 上传文件列表
      loading: false
    }
  },
  mounted () {
    // NProgress.configure({
    //   parent: '.upload-box .el-dialog__footer',
    //   speed: 100
    // })
  },
  methods: {
    // 点击上传
    saveBtn (confirmFlag) {
      const data = new FormData()
      // console.log(this.fileList)
      // 判断无文件禁止上传
      if (this.fileList.length < 1) {
        this.$message.warning('上传文件不能为空')
        return false
      }
      // 校验文件大小
      if (!this.checkSize()) {
        return false
      }

      // 如果是继续提交的
      if (confirmFlag) {
        data.append('confirmFlag', confirmFlag)
      }

      this.fileList.forEach((everyFile) => {
        if (this.fileKey && this.fileKey[everyFile.name]) {
          data.append(this.fileKey[everyFile.name], everyFile.raw)
        } else if (this.suffixKey) {
          // 匹配文件后缀名
          const fileName = everyFile.name
          const fileExtension = fileName.substring(
            fileName.lastIndexOf('.') + 1
          )
          // eslint-disable-next-line no-unused-vars
          for (const key in this.suffixKey) {
            // 值需要以数组行式定义
            if (this.suffixKey[key] && Array.isArray(this.suffixKey[key])) {
              if (this.suffixKey[key].includes(fileExtension)) {
                data.append(key, everyFile.raw)
              }
            }
          }
        } else {
          data.append('file', everyFile.raw)
        }
      })
      // 校验额外数据是否必填，然后append到formData中，必填的数据则校验并报错
      if (Object.keys(this.extra).length) {
        const inputObj = {}
        // eslint-disable-next-line
        for (const key in this.extra) {
          if (![null, undefined, ''].includes(this.extra[key].value)) {
            // 参数是否聚合
            if (this.inputParam) {
              if (this.extra[key].value === 'false') {
                inputObj[key] = false
              } else if (this.extra[key].value === 'true') {
                inputObj[key] = true
              } else {
                inputObj[key] = this.extra[key].value
              }
            } else {
              data.append(key, this.extra[key].value)
            }
          } else {
            if (
              (typeof this.extra[key].require === 'function' &&
                this.extra[key].require()) ||
              (typeof this.extra[key].require === 'boolean' &&
                this.extra[key].require)
            ) {
              this.$message.warning(this.extra[key].message)
              return
            }
          }
        }
        if (this.inputParam) {
          data.append(this.inputParam, JSON.stringify(inputObj))
        }
        // 触发对data的继续append回调
        this.$emit('dataAppend', data)
      }
      // 增加上传前的校验,可用来保存前的一步操作,二次确认后再手动调用saveBtn接口
      if (this.check) {
        this.$emit('checkConfirm')
        return false
      }
      if (this.loading) {
        return false
      }
      // NProgress.start()
      this.loading = true
      return this.$http
        .post(this.url, data, { timeout: 1000 * 60 * 60 })
        .then(({ data: res }) => {
          // NProgress.done()
          if (res.code === 0) {
            if (res.data && res.data.importFlag === 1) {
              this.$confirm(
                '导入价格和集团其他公司不一致，请和客户确认。是否继续导入？',
                '价格不一致',
                {
                  confirmButtonText: '继续导入',
                  cancelButtonText: '查看明细',
                  type: 'warning'
                }
              )
                .then(() => {
                  // 再次调用
                  this.saveBtn(true)
                })
                .catch(() => {
                  // 查看明细
                  this.$emit('showFail')
                })
              this.loading = false
              return
            }
            this.$message({
              message: this.message || '上传成功',
              type: 'success'
            })
            const timer = setTimeout(() => {
              clearInterval(timer)
              this.handleClose()
              this.loading = false
            }, 300)
            this.$emit('fileSuccess', true, res)
            this.$emit('returnContent', res)
          } else if (res.code === 910002) {
            const timer = setTimeout(() => {
              clearInterval(timer)
              this.handleClose()
              this.loading = false
            }, 300)
            this.$emit('fileSuccess', true, res)
            this.$emit('returnContent', res)
          } else {
            this.$emit('fileSuccess', false, res)
            this.fileList = []
            // this.$message({
            //   message: res.message,
            //   type: 'error'
            // })
            this.loading = false
          }
        })
        .catch(() => {
          this.fileList = []
          this.loading = false
          // NProgress.done()
        })
    },
    // 文件超出个数限制时的钩子
    handleExceed (files, fileList) {
      this.$message.warning(
        `当前限制选择 ${this.limit} 个文件,请删除后再次上传`
      )
    },
    /* 上传文件之前的钩子 因设置了auto-upload为false，如果使用before-upload，虽有提示，但是还是会请求服务器 */
    beforeUpload (file, fileList) {
      this.$emit('beforeUpload', {
        file,
        fileList
      })
      // 1、判断文件名是否重复，不允许上传相同文件
      const existFile = fileList
        .slice(0, fileList.length - 1)
        .find((f) => f.name === file.name)
      if (existFile) {
        fileList.pop()
        this.$message.warning(file.name + ' 文件已存在！')
      }
      // 2、上传参数校验，如过有上传参数 则校验文件名称
      if (this.fileKey && !this.fileKey[file.name]) {
        fileList.pop()
        let tip = ''
        Object.keys(this.fileKey).forEach((item) => {
          tip += `、${item}`
        })
        this.$message.warning('请上传以下名称的文件' + tip)
      }
      this.fileList = fileList
    },
    // 删除前确认
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    // 删除文件
    handleRemove (file, fileList) {
      // console.log(file, fileList)
      this.$emit('fileRemove', {
        file,
        fileList
      })
      this.fileList = fileList
    },
    // 上传前校验文件
    checkSize () {
      let isSizeReady = true
      this.fileList.forEach((file) => {
        const isLt2M = file.size / 1024 / 1024 < this.size
        if (!isLt2M) {
          this.$message.warning(`上传文件大小不能超过 ${this.size}MB!`)
          isSizeReady = false
          return false
        }
      })
      return isSizeReady
    },
    // 上传前校验文件
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < this.size
      if (!isLt2M) {
        this.$message.warning(`上传文件大小不能超过 ${this.size}MB!`)
        return false
      }
      if (this.fileList.length < 1) {
        this.$message.warning('上传文件不能为空')
        return false
      }
    },
    // 上传成功的钩子
    handleAvatarSuccess (res, file) {
      console.log('上传成功的钩子')
      if (res.code === 0) {
        this.$message({
          message: '上传成功',
          type: 'success'
        })
        this.handleClose()
        this.$emit('fileSuccess', true)
        this.$emit('fileResult', res)
      } else {
        this.$message({
          message: res.message,
          type: 'error'
        })
      }
    },
    // 关闭
    handleClose () {
      this.$emit('update:dialogVisible', false)
    },
    // 下载模版
    downTemp (url) {
      if (typeof url === 'function') {
        url()
        return
      }
      window.location.href = url
    }
  }
}
</script>

<style scoped lang="scss">
.upload-box {
  ::v-deep .el-dialog__body {
    padding: 10px 30px;
  }
  .el-upload__tip {
    margin-top: 20px;
  }
  ::v-deep #nprogress .bar {
    background: #1d65a8 !important;
    height: 4px !important;
    bottom: 0 !important;
  }
  ::v-deep .spinner {
    display: none !important;
  }
}
.upload-draggable{
  ::v-deep .el-upload {
    width: 100% !important;
    .el-upload-dragger {
      width: 100% !important;
    }
  }
}
</style>
<style>
.upload-box a {
  text-decoration: none;
}
</style>
